import React from 'react'
import OrangeCheckboxIcon from '../../assets/img/orange-checkbox-icon.svg'
import YellowCheckboxIcon from '../../assets/img/yellow-checkbox-icon.svg'
import PurpleCheckboxIcon from '../../assets/img/purple-checkbox-icon.svg'
import BlueCheckboxIcon from '../../assets/img/blue-checkbox-icon.svg'
import grayCheckboxIcon from '../../assets/img/gray-checkbox-icon.svg'
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from '../../components/loader';
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { apiUrl } from "../../utils/url";
import { useHistory } from 'react-router-dom';
import SideBar from '../side-bar';
import PageHeader from '../page-header';
import tickIcon from "../../assets/img/white-tick.svg";
import { audiencePosts as manageStripePost } from '../../services/postRequests/audience'
import lifetime from "../../assets/img/lifetime.svg"
import SettingsHeader from '../settings/settings-header'

const NewUpgradePage = () => {

    const [error, setError] = useState([])
    const history = useHistory()
    const { slug } = useSelector(state => state?.slugReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const pro = useSelector(state => state?.proReducer);
    const planType = useSelector(state => state?.plantypeReducer);
    const [upgradeType, setUpgradeType] = useState("monthly")
    const creditsDataReducer = useSelector(state => state?.creditsDataReducer)
    function togglePlans(e) {
        const selectedValue = e.target.value;
        setUpgradeType(selectedValue);
    }
    const handleSubmit = (e) => {
        showLoader();
        setError([])
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)

        const formdata = new FormData();
        formdata.append('project',slug);
        formdata.append('type',upgradeType ? upgradeType : "monthly");
        formdata.append('plan_type',e.target.name);
        formdata.append("tolt_referral", window.tolt_referral??'');
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/subscribe-plan", requestOptions)
            .then(async (res) => {
                hideLoader()
                const response = await res?.json();
                if (response?.status_code == 200) {

                        location.href = response?.data?.url;

                        localStorage.setItem("temp_slug",response?.data?.slug);
                        localStorage.setItem("last_activity", `/project/${response?.data?.slug}/campaigns`)
                        localStorage.setItem("plan_type",e.target.name)
                        localStorage.setItem("period",type)
                }
                else {
                    setError(getErrors(response?.errors))
                    toast.error(response?.status_message)
                }
            }).catch((err) => hideLoader())

           

    }

    const manageStripe = (e) => {
        showLoader()
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("project", slug)
        const api = apiUrl + `/manage-subscription`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders
        }
        manageStripePost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })
    }
    return (
            <div className='up-cont-u'>
                <section>
                <SettingsHeader page={"Plan"} activePage={'upgradePage'} description={'View your plan information or switch plans according to your needs'}/>                
                <div className='choose-plan-container upgrade-card'>
                    <div className="plan-header-container">
                        <h1 className='settings-section-heading mb-0'>
                            Compare Plans
                        </h1>
                        <div className='choose-plan-type'>
                            <div class="toggle-input-checkbox">
                                <input type="radio" id="text_align_left" name="planType" onChange={togglePlans} checked={upgradeType == "monthly"} style={{ display: "none" }}  value={"monthly"} />
                                <label for="text_align_left" className='monthly' > <span > Monthly</span></label>
                                <input type="radio" id="text_align_right" name="planType" onChange={togglePlans} checked={upgradeType == "yearly"} style={{ display: "none" }} value={"yearly"}  />
                                <label for="text_align_right"  className='yearly' > <span > Yearly </span><span className='yearly-discount-badge'>-25%</span></label>
                            </div>
                        </div>
                    </div>
                    <div className='plan-cards-container'  id="monthly-plans">
                    {/* free plan */}
                    <div className='plan-card'>
                        <div className='card-text-container'>
                            <div className={`plan-headings`}>Free</div>
                            <div className={`plan-headings`}>$0/mo</div>
                            <div className='billing-type'>Billed monthly</div>
                        </div>
                        <div className='w-100'>
                            <div className='credits-button mb-1'>
                                10 credits/month
                            </div>
                            {(!pro) && (!planType || planType == 'basic')? 
                            <button className='credits-button active'>Current Plan</button>
                            :
                            <button className='credits-button' onClick={manageStripe}>Downgrade</button>
                            }
                        </div>
                        <div className='plan-used-for'>
                            Explore GenPage for free
                        </div>
                        <div className='features-list-container'>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>GenPage Designer</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>10 Landing Pages</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>500 Leads Imported</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>Unlimited Campaigns</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>Unlimited Users</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>Custom Domain</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>Custom Variables</p>
                            </div>
                            <div className='plan-feature-list'>
                                <img src={grayCheckboxIcon} alt="" />
                                <p className='feature-list-text list-u'>Chat & Email Support</p>
                            </div>
                        </div>
                    </div>     
                        {/* pro plan */}
                        <div className='plan-card'>
                                <div className='card-text-container'>
                                    <div className='plan-headings pro'>Pro</div>
                                    <div className={`${upgradeType == 'yearly' && 'text-blue '} plan-headings`}>{upgradeType == "monthly" ? '$59/mo' : '$44/mo'}</div>
                                    <div className='billing-type'>Billed {upgradeType}</div>
                                </div>
                            <div className='w-100'>
                                <div className='credits-button mb-1'>
                                300 credits/month
                                </div>
                                {(pro == 1 || pro == true) && (planType == 'pro') && (creditsDataReducer?.duration_type == 'unlimited' || creditsDataReducer?.duration_type == upgradeType) ? 
                                    <button className='credits-button credits-button-primary active'>Current Plan</button>
                                    :
                                    <button onClick={(e) => handleSubmit(e)} name="pro" className='credits-button credits-button-primary'>{pro == 1 && (planType == 'scale' || planType != 'starter' || planType != 'sender')? 'Downgrade ':'Upgrade '} to Pro</button>
                                }
                            </div>
                            <div className='plan-used-for'>
                            For freelancers and SMBs
                            </div>
                            <div className='features-list-container'>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>GenPage Designer</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>300 Landing Pages</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>5,000 Leads Imported</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Unlimited Campaigns</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Unlimited Users</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Custom Domain</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Custom Variables</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Chat & Email Support</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Remove ‘Made With GenPage’ Branding</p>
                                </div>
                            </div>
                        </div>
                        {/* scale plan */}
                        <div className='scale-plan'>
                            <div className='most-popular'>
                                Most Popular
                            </div>
                            <div className='plan-card plan-card-scale'>
                                    <div className='card-text-container'>
                                        <div className='plan-headings scale'>Scale</div>
                                        <div className={`${upgradeType == 'yearly' && 'text-blue '} plan-headings`}>{upgradeType == "monthly" ? '$129/mo' : '$96/mo'}</div>
                                        <div className='billing-type'>Billed {upgradeType}</div>
                                </div>
                                <div className='w-100'>
                                    <div className='credits-button mb-1'>
                                        1,000 credits/month
                                    </div>
                                    {(pro == 1 || pro == true) && (planType == 'scale') && (creditsDataReducer?.duration_type == 'unlimited' || creditsDataReducer?.duration_type == upgradeType)  ? 
                                        <button className='credits-button credits-button-primary active'>Current Plan</button>
                                        :
                                        <button onClick={(e) => handleSubmit(e)} name="scale" className='credits-button credits-button-primary'>Upgrade to Scale</button>
                                    }
                                </div>
                                <div className='plan-used-for'>
                                    For startups and agencies
                                </div>
                                <div className='features-list-container'>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>GenPage Designer</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>1,000 Landing Pages</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>20,000 Leads Imported</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Unlimited Campaigns</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Unlimited Users</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Custom Domain</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Custom Variables</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Priority Support</p>
                                    </div>
                                    <div className='plan-feature-list'>
                                        <img src={grayCheckboxIcon} alt="" />
                                        <p className='feature-list-text list-u'>Remove ‘Made With GenPage’ Branding</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Ultimate plan */}
                        <div className='plan-card'>
                                <div className='card-text-container'>
                                    <div className='plan-headings ultimate'>Ultimate</div>
                                    <div className={`${upgradeType == 'yearly' && 'text-blue '} plan-headings`}>{upgradeType == "monthly" ? '$259/mo' : '$194/mo'}</div>
                                    <div className='billing-type'>Billed {upgradeType}</div>
                            </div>
                            <div className='w-100'>
                                <div className='credits-button mb-1'>
                                    3,000+ credits/month
                                </div>
                                {(pro == 1 || pro == true) && (planType == 'ultimate') ? 
                                    <button className='credits-button credits-button-primary active'>Current Plan</button>
                                    :
                                    <a href='https://www.genpage.ai/sales' className='text-decoration-none credits-button bg-dark text-light'>Talk to sales</a>
                                }
                            </div>
                            <div className='plan-used-for'>
                                For large organizations
                            </div>
                            <div className='features-list-container'>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>GenPage Designer</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>3,000+ Landing Pages</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>50,000+ Leads Imported</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Unlimited Campaigns</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Unlimited Users</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Custom Domain</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Custom Variables</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Account Manager</p>
                                </div>
                                <div className='plan-feature-list'>
                                    <img src={grayCheckboxIcon} alt="" />
                                    <p className='feature-list-text list-u'>Remove ‘Made With GenPage’ Branding</p>
                                </div>
                            </div>
                        </div>
                    </div> 

                    
                </div>
                </section>
                   
            </div>

        
    )
}
export default NewUpgradePage;